import { useDataAttributes } from '@data-attributes/use-data-attributes';
import { ErrorMessage } from '@eika/attention-message';
import { SmallButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';
import { Skeleton } from '@eika/skeleton';
import { usePdfNameAndUrl } from '@react-query/hooks/query/use-pdf';
import { PdfKey } from '@react-query/types';
import { useTranslation } from '@translations';

export const Documents = () => <DocumentAvtaleOmAksjesparekonto />;

const DocumentAvtaleOmAksjesparekonto = () => {
    const { documentConsentDataAttributes } = useDataAttributes();
    const { data, error, refetch, isPending } = usePdfNameAndUrl(PdfKey.ASK_FOR_CHILD_PDF);
    const { tryAgain, processSummary } = useTranslation();

    if (isPending) {
        return (
            <div className="document-loading">
                <Skeleton width={24} height={24} count={1} />
                <span>{processSummary.documentConsent.fetchingDocument}</span>
            </div>
        );
    }

    if (error) {
        return (
            <ErrorMessage
                id="2"
                text={processSummary.documentConsent.couldNotFetchDocument}
                icon={IconTypes.LUKK_24}
                clickableItem={
                    <SmallButton
                        buttonType="negative"
                        onClick={() => {
                            refetch();
                        }}
                    >
                        {tryAgain}
                    </SmallButton>
                }
            />
        );
    }

    const { name, url } = data;

    return (
        <Link
            className="document-consent-card__elements__documents__document"
            href={url}
            icon={IconTypes.NEDLASTING_24}
            {...documentConsentDataAttributes.documentAvtaleOmAksjesparekonto}
        >
            {name}
        </Link>
    );
};
